export default __webpack_public_path__ + "static/PECAN_WY-a78993529e58ae6696b39ac14f3b5df3.pdf";